var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _vm.proxyMode
                ? _c(
                    "div",
                    { staticClass: "proxy-banner" },
                    [
                      _c("a-icon", { attrs: { type: "info-circle" } }),
                      _vm._v(
                        " 已进入门店后台（" +
                          _vm._s(_vm.proxyStoreName) +
                          "），当前总店标签页同步切换为门店身份\n        "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "proxy-back",
                          on: { click: _vm.handleBackToHq },
                        },
                        [_vm._v("返回总店")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "page-header-bar" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { icon: "arrow-left" },
                      on: { click: _vm.goBackToList },
                    },
                    [_vm._v("返回列表")]
                  ),
                ],
                1
              ),
              !_vm.noStore
                ? [
                    _c(
                      "a-tabs",
                      {
                        model: {
                          value: _vm.activeTab,
                          callback: function ($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab",
                        },
                      },
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "基本信息" } },
                          [
                            _c(
                              "a-form",
                              { staticClass: "setting-form" },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店简称",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                      required: "",
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        placeholder:
                                          "门店简称（招牌字号，区别于营业执照企业全称）",
                                      },
                                      model: {
                                        value: _vm.form.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "name", $$v)
                                        },
                                        expression: "form.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.storeId
                                  ? _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "门店ID",
                                          labelCol: _vm.formLabelCol,
                                          wrapperCol: _vm.formWrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "340px" },
                                          attrs: {
                                            value: _vm.form.id,
                                            disabled: "",
                                          },
                                        }),
                                        _c(
                                          "a-button",
                                          {
                                            staticClass: "mar-l10",
                                            on: { click: _vm.copyStoreId },
                                          },
                                          [_vm._v("复制")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店图片",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("j-image-upload", {
                                      attrs: {
                                        bizPath: "material",
                                        text: "上传图片",
                                        isMultiple: "",
                                      },
                                      model: {
                                        value: _vm.form.media,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "media", $$v)
                                        },
                                        expression: "form.media",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "联系人",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.form.contact || "未维护")
                                        ),
                                      ]
                                    ),
                                    !_vm.form.contact
                                      ? _c(
                                          "span",
                                          { staticClass: "readonly-tip" },
                                          [
                                            _vm._v(
                                              "请到 系统管理→系统配置→基本资料 完善"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店电话",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.form.phone || "未维护")
                                        ),
                                      ]
                                    ),
                                    !_vm.form.phone
                                      ? _c(
                                          "span",
                                          { staticClass: "readonly-tip" },
                                          [
                                            _vm._v(
                                              "请到 系统管理→系统配置→基本资料 完善"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "所属区域",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [_vm._v(_vm._s(_vm.areaText || "未维护"))]
                                    ),
                                    !_vm.areaText
                                      ? _c(
                                          "span",
                                          { staticClass: "readonly-tip" },
                                          [
                                            _vm._v(
                                              "请到 系统管理→系统配置→地址定位与地图服务 完善"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "地址",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "readonly-value" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.form.address || "未维护")
                                        ),
                                      ]
                                    ),
                                    !_vm.form.address
                                      ? _c(
                                          "span",
                                          { staticClass: "readonly-tip" },
                                          [
                                            _vm._v(
                                              "请到 系统管理→系统配置→地址定位与地图服务 完善"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店编号",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: { placeholder: "请输入门店编号" },
                                      model: {
                                        value: _vm.form.storeNumber,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "storeNumber", $$v)
                                        },
                                        expression: "form.storeNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店类型",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "a-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.storeType,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "storeType", $$v)
                                          },
                                          expression: "form.storeType",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-radio",
                                          { attrs: { value: "1" } },
                                          [_vm._v("直营店")]
                                        ),
                                        _c(
                                          "a-radio",
                                          { attrs: { value: "2" } },
                                          [_vm._v("加盟店")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店标签",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: { placeholder: "请输入门店标签" },
                                      model: {
                                        value: _vm.form.label,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "label", $$v)
                                        },
                                        expression: "form.label",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "管理员账号",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "main-user-card" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "muser-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "muser-label" },
                                              [_vm._v("登录名")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "muser-value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mainUser.loginName ||
                                                      "-"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "muser-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "muser-label" },
                                              [_vm._v("手机号")]
                                            ),
                                            _c("a-input", {
                                              staticStyle: { width: "220px" },
                                              attrs: {
                                                placeholder:
                                                  "请输入管理员手机号",
                                              },
                                              model: {
                                                value: _vm.mainUser.phonenum,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.mainUser,
                                                    "phonenum",
                                                    $$v
                                                  )
                                                },
                                                expression: "mainUser.phonenum",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "muser-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "muser-label" },
                                              [_vm._v("密码")]
                                            ),
                                            _c("a-input-password", {
                                              staticStyle: { width: "220px" },
                                              attrs: {
                                                placeholder:
                                                  "留空不修改；输入即重置",
                                              },
                                              model: {
                                                value: _vm.mainUser.password,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.mainUser,
                                                    "password",
                                                    $$v
                                                  )
                                                },
                                                expression: "mainUser.password",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "muser-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "muser-label" },
                                              [_vm._v("微信")]
                                            ),
                                            _vm.mainUser.weixinBound
                                              ? [
                                                  _c(
                                                    "a-tag",
                                                    {
                                                      attrs: { color: "green" },
                                                    },
                                                    [_vm._v("已绑定")]
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "muser-link",
                                                      on: {
                                                        click:
                                                          _vm.handleUnbindWeixin,
                                                      },
                                                    },
                                                    [_vm._v("解绑")]
                                                  ),
                                                ]
                                              : [
                                                  _c("a-tag", [
                                                    _vm._v("未绑定"),
                                                  ]),
                                                ],
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "field-tip inline-tip",
                                              },
                                              [
                                                _vm._v(
                                                  "绑定由管理员在微信端登录时完成"
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                        _c(
                                          "a-button",
                                          {
                                            staticStyle: {
                                              "margin-top": "8px",
                                            },
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                            },
                                            on: {
                                              click: _vm.handleSaveMainUser,
                                            },
                                          },
                                          [_vm._v("保存管理员信息")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-footer" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.handleSaveStore },
                                  },
                                  [_vm._v("保存")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "mar-l10",
                                    on: { click: _vm.goBackToList },
                                  },
                                  [_vm._v("取消")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "门店信息" } },
                          [
                            _c(
                              "a-form",
                              { staticClass: "setting-form" },
                              [
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "门店简介",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("a-textarea", {
                                      attrs: {
                                        placeholder: "请输入门店简介",
                                        rows: 4,
                                      },
                                      model: {
                                        value: _vm.form.introduction,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "introduction",
                                            $$v
                                          )
                                        },
                                        expression: "form.introduction",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "主营产品",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: { placeholder: "请输入主营产品" },
                                      model: {
                                        value: _vm.form.mainDishes,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "mainDishes", $$v)
                                        },
                                        expression: "form.mainDishes",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "人均消费",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "400px" },
                                      attrs: {
                                        placeholder: "请输入人均消费",
                                        addonAfter: "元",
                                      },
                                      model: {
                                        value: _vm.form.perCapita,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "perCapita", $$v)
                                        },
                                        expression: "form.perCapita",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "商家环境",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c("j-image-upload", {
                                      attrs: {
                                        bizPath: "material",
                                        text: "上传图片",
                                        isMultiple: "",
                                      },
                                      model: {
                                        value: _vm.form.environment,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "environment", $$v)
                                        },
                                        expression: "form.environment",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-form-item",
                                  {
                                    attrs: {
                                      label: "资质与进件",
                                      labelCol: _vm.formLabelCol,
                                      wrapperCol: _vm.formWrapperCol,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "mch-card" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mch-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mch-label" },
                                              [_vm._v("微信支付渠道")]
                                            ),
                                            _c(
                                              "a-tag",
                                              {
                                                attrs: {
                                                  color: _vm.wxApplied
                                                    ? "green"
                                                    : "orange",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.wxApplied
                                                      ? "已进件"
                                                      : "未进件"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "mch-row" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "mch-label" },
                                              [_vm._v("支付宝渠道")]
                                            ),
                                            _c(
                                              "a-tag",
                                              {
                                                attrs: {
                                                  color: _vm.aliApplied
                                                    ? "green"
                                                    : "orange",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.aliApplied
                                                      ? "已进件"
                                                      : "未进件"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        !_vm.applyBlocked
                                          ? _c(
                                              "a-button",
                                              {
                                                staticStyle: {
                                                  "margin-top": "8px",
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                                on: { click: _vm.goMchApply },
                                              },
                                              [_vm._v("去进件")]
                                            )
                                          : _vm._e(),
                                        _vm.applyBlocked
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "readonly-tip",
                                                staticStyle: {
                                                  display: "inline-block",
                                                  "margin-top": "8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "收款由总店统一代收，无需进件"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.tenantProfileLoaded
                                          ? _c(
                                              "div",
                                              { staticClass: "qual-block" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "qual-line" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "qual-label",
                                                      },
                                                      [_vm._v("主体营业执照")]
                                                    ),
                                                    _vm.tenantProfile
                                                      .licenseCopy.length
                                                      ? [
                                                          _vm._l(
                                                            _vm.qualThumbs
                                                              .licenseCopy,
                                                            function (url, i) {
                                                              return [
                                                                url
                                                                  ? _c("img", {
                                                                      key:
                                                                        "lc" +
                                                                        i,
                                                                      staticClass:
                                                                        "qual-thumb",
                                                                      attrs: {
                                                                        src: url,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.previewImg(
                                                                              url
                                                                            )
                                                                          },
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                              ]
                                                            }
                                                          ),
                                                        ]
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "qual-empty",
                                                          },
                                                          [_vm._v("未维护")]
                                                        ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "qual-line" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "qual-label",
                                                      },
                                                      [_vm._v("经营许可证")]
                                                    ),
                                                    _vm.tenantProfile
                                                      .qualificationPics.length
                                                      ? [
                                                          _vm._l(
                                                            _vm.qualThumbs
                                                              .qualificationPics,
                                                            function (url, i) {
                                                              return [
                                                                url
                                                                  ? _c("img", {
                                                                      key:
                                                                        "qp" +
                                                                        i,
                                                                      staticClass:
                                                                        "qual-thumb",
                                                                      attrs: {
                                                                        src: url,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.previewImg(
                                                                              url
                                                                            )
                                                                          },
                                                                      },
                                                                    })
                                                                  : _vm._e(),
                                                              ]
                                                            }
                                                          ),
                                                        ]
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "qual-empty",
                                                          },
                                                          [_vm._v("未维护")]
                                                        ),
                                                  ],
                                                  2
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "field-tip" },
                                                  [
                                                    _vm._v(
                                                      "资质随商户进件提交时维护（进件表单为唯一录入点）"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-collapse",
                              {
                                staticClass: "license-collapse",
                                attrs: { bordered: false },
                              },
                              [
                                _c(
                                  "a-collapse-panel",
                                  {
                                    key: "license",
                                    attrs: {
                                      header:
                                        "分店资质差异补充（与主体执照不同时才需填写）",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-form",
                                      { staticClass: "setting-form" },
                                      [
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "营业执照",
                                              labelCol: _vm.formLabelCol,
                                              wrapperCol: _vm.formWrapperCol,
                                            },
                                          },
                                          [
                                            _c("j-image-upload", {
                                              attrs: {
                                                bizPath: "material",
                                                text: "上传图片",
                                                isMultiple: "",
                                              },
                                              model: {
                                                value: _vm.form.license,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "license",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.license",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "a-form-item",
                                          {
                                            attrs: {
                                              label: "食品安全档案",
                                              labelCol: _vm.formLabelCol,
                                              wrapperCol: _vm.formWrapperCol,
                                            },
                                          },
                                          [
                                            _c("j-image-upload", {
                                              attrs: {
                                                bizPath: "material",
                                                text: "上传图片",
                                                isMultiple: "",
                                              },
                                              model: {
                                                value: _vm.form.foodRecords,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "foodRecords",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.foodRecords",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-footer" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      loading: _vm.saving,
                                    },
                                    on: { click: _vm.handleSaveStore },
                                  },
                                  [_vm._v("保存")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticClass: "mar-l10",
                                    on: { click: _vm.goBackToList },
                                  },
                                  [_vm._v("取消")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-tab-pane",
                          { key: "3", attrs: { tab: "提现管理" } },
                          [
                            _vm.storeId
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "withdraw-balance" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "balance-item main" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "balance-label" },
                                            [_vm._v("可提现金额（元）")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "balance-value" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fmtMoney(
                                                    _vm.withdrawSummary
                                                      .available
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "balance-item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "balance-label" },
                                            [_vm._v("在途申请（元）")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "balance-num" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fmtMoney(
                                                    _vm.withdrawSummary.pending
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "balance-item" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "balance-label" },
                                            [_vm._v("累计已提现（元）")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "balance-num" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fmtMoney(
                                                    _vm.withdrawSummary.paid
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "field-tip" }, [
                                    _vm._v(
                                      "计提累计：¥" +
                                        _vm._s(
                                          _vm.fmtMoney(
                                            _vm.withdrawSummary.totalPayable
                                          )
                                        ) +
                                        "（可提现 = 计提累计 − 累计已提现 − 在途申请）"
                                    ),
                                  ]),
                                  _c(
                                    "a-card",
                                    {
                                      staticStyle: {
                                        "margin-top": "16px",
                                        "max-width": "760px",
                                      },
                                      attrs: {
                                        size: "small",
                                        title: "提现申请",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-form",
                                        { staticClass: "setting-form" },
                                        [
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "收款方式",
                                                labelCol: _vm.formLabelCol,
                                                wrapperCol: _vm.formWrapperCol,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-radio-group",
                                                {
                                                  model: {
                                                    value:
                                                      _vm.withdrawForm
                                                        .accountType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.withdrawForm,
                                                        "accountType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "withdrawForm.accountType",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-radio",
                                                    {
                                                      attrs: { value: "bank" },
                                                    },
                                                    [_vm._v("银行卡")]
                                                  ),
                                                  _c(
                                                    "a-radio",
                                                    {
                                                      attrs: {
                                                        value: "alipay",
                                                      },
                                                    },
                                                    [_vm._v("支付宝")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.withdrawForm.accountType ===
                                          "bank"
                                            ? [
                                                _c(
                                                  "a-form-item",
                                                  {
                                                    attrs: {
                                                      label: "开户名",
                                                      labelCol:
                                                        _vm.formLabelCol,
                                                      wrapperCol:
                                                        _vm.formWrapperCol,
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入银行卡开户名",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.withdrawForm
                                                            .accountName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.withdrawForm,
                                                            "accountName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "withdrawForm.accountName",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "a-form-item",
                                                  {
                                                    attrs: {
                                                      label: "银行卡号",
                                                      labelCol:
                                                        _vm.formLabelCol,
                                                      wrapperCol:
                                                        _vm.formWrapperCol,
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入银行卡号",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.withdrawForm
                                                            .bankNo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.withdrawForm,
                                                            "bankNo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "withdrawForm.bankNo",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "a-form-item",
                                                  {
                                                    attrs: {
                                                      label: "开户行",
                                                      labelCol:
                                                        _vm.formLabelCol,
                                                      wrapperCol:
                                                        _vm.formWrapperCol,
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入开户行（如：工商银行xx支行）",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.withdrawForm
                                                            .bankName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.withdrawForm,
                                                            "bankName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "withdrawForm.bankName",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "a-form-item",
                                                  {
                                                    attrs: {
                                                      label: "支付宝姓名",
                                                      labelCol:
                                                        _vm.formLabelCol,
                                                      wrapperCol:
                                                        _vm.formWrapperCol,
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入支付宝实名姓名",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.withdrawForm
                                                            .accountName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.withdrawForm,
                                                            "accountName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "withdrawForm.accountName",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "a-form-item",
                                                  {
                                                    attrs: {
                                                      label: "支付宝账号",
                                                      labelCol:
                                                        _vm.formLabelCol,
                                                      wrapperCol:
                                                        _vm.formWrapperCol,
                                                      required: "",
                                                    },
                                                  },
                                                  [
                                                    _c("a-input", {
                                                      staticStyle: {
                                                        width: "400px",
                                                      },
                                                      attrs: {
                                                        placeholder:
                                                          "请输入支付宝账号（手机号/邮箱）",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.withdrawForm
                                                            .alipayAccount,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.withdrawForm,
                                                            "alipayAccount",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "withdrawForm.alipayAccount",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                label: "提现金额",
                                                labelCol: _vm.formLabelCol,
                                                wrapperCol: _vm.formWrapperCol,
                                                required: "",
                                              },
                                            },
                                            [
                                              _c("a-input-number", {
                                                staticStyle: { width: "200px" },
                                                attrs: {
                                                  min: 0,
                                                  max:
                                                    Number(
                                                      _vm.withdrawSummary
                                                        .available
                                                    ) || 0,
                                                  precision: 2,
                                                  placeholder: "请输入提现金额",
                                                },
                                                model: {
                                                  value:
                                                    _vm.withdrawForm
                                                      .applyAmount,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.withdrawForm,
                                                      "applyAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "withdrawForm.applyAmount",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "field-tip inline-tip",
                                                },
                                                [
                                                  _vm._v(
                                                    "可提现余额 ¥" +
                                                      _vm._s(
                                                        _vm.fmtMoney(
                                                          _vm.withdrawSummary
                                                            .available
                                                        )
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-item",
                                            {
                                              attrs: {
                                                wrapperCol: {
                                                  span: 18,
                                                  offset: 6,
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "a-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    loading:
                                                      _vm.withdrawSubmitting,
                                                    disabled:
                                                      _vm.withdrawSummary
                                                        .hasPendingApplication,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.handleWithdrawSubmit,
                                                  },
                                                },
                                                [_vm._v("提交申请")]
                                              ),
                                              _vm.withdrawSummary
                                                .hasPendingApplication
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "field-tip inline-tip",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "已有待审批申请，请等待总部处理后再提交"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "section-title",
                                      staticStyle: { "margin-top": "16px" },
                                    },
                                    [_vm._v("提现记录")]
                                  ),
                                  _c("a-table", {
                                    attrs: {
                                      size: "middle",
                                      bordered: "",
                                      rowKey: "id",
                                      columns: _vm.withdrawColumns,
                                      dataSource: _vm.withdrawList,
                                      loading: _vm.withdrawLoading,
                                      pagination: _vm.withdrawPagination,
                                    },
                                    on: { change: _vm.onWithdrawPageChange },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "withdrawStatus",
                                          fn: function (text) {
                                            return [
                                              _c(
                                                "a-tag",
                                                {
                                                  attrs: {
                                                    color: (
                                                      _vm.withdrawStatusMap[
                                                        text
                                                      ] || {}
                                                    ).color,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      (
                                                        _vm.withdrawStatusMap[
                                                          text
                                                        ] || {}
                                                      ).text || text
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4097946770
                                    ),
                                  }),
                                ]
                              : _c("a-empty", {
                                  attrs: {
                                    description: "保存门店后可使用提现管理",
                                  },
                                }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                : _c(
                    "div",
                    { staticClass: "no-store-tip" },
                    [
                      _c("a-empty", {
                        attrs: {
                          description:
                            "当前账号未绑定门店，请从门店列表选择门店进行设置或新增门店",
                        },
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.goBackToList },
                        },
                        [_vm._v("前往门店列表")]
                      ),
                    ],
                    1
                  ),
              _c(
                "a-modal",
                {
                  attrs: {
                    visible: _vm.previewVisible,
                    footer: null,
                    width: 720,
                    title: "资质图片",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "100%" },
                    attrs: { src: _vm.previewImage, alt: "资质图片" },
                  }),
                ]
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }